export default __webpack_public_path__ + "static/media/start.f8c1025b.svg";